import { BrushFirmType } from '@/shared/types'

export class BrushMapFirm {
  public firm: BrushFirmType

  constructor() {
    this.initFirm()
  }

  public initFirm(): void {
    this.firm = this.getInitialFirm()
  }

  public updateFirm(firm: BrushFirmType): void {
    const { nameFirm, firstGroup, secondGroup } = firm

    this.firm.nameFirm = nameFirm
    this.firm.firstGroup = firstGroup
    this.firm.secondGroup = secondGroup
  }

  private getInitialFirm(): BrushFirmType {
    return {
      nameFirm: 'Curaprox',
      firstGroup: 'PRIME',
      secondGroup: 'PERIO',
    }
  }
}
